import React from 'react';

import DestructiveActionMenuItem from '@dashboard/components/destructive-action-triggers/DestructiveActionMenuItem';
import { alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import { useArchiveWaypointTemplateMutation } from '@dashboard/generated/wp/platform';
import usePlatformNavigator from '@dashboard/hooks/navigate/usePlatformNavigator';
import useCurrentTemplatesQuery from '@dashboard/pages/platforms/WaypointTemplatesList/useCurrentTemplatesQuery';
import { ArchiveOutlined } from '@mui/icons-material';

type Props = {
  redirect?: boolean;
  id: string;
  onClose: () => void;
};

export default function ArchiveTemplateButton({ redirect, id, onClose }: Props) {
  const [executeMutation, { loading }] = useArchiveWaypointTemplateMutation();
  const { refetch } = useCurrentTemplatesQuery();
  const navigator = usePlatformNavigator();

  const onClick = async () => {
    await executeMutation({ variables: { id } });
    alertSuccess('Template archived');
    refetch();
    if (redirect) {
      navigator.listTemplates();
    }
    onClose();
  };
  return (
    <DestructiveActionMenuItem
      buttonIcon={<ArchiveOutlined fontSize="small" />}
      buttonText="Archive"
      title="Archive template?"
      description="This will move this workflow out of your templates page."
      loading={loading}
      onSubmit={onClick}
      confirmButtonLabel="Yes, archive"
    />
  );
}
